import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { companyQueryKeys } from "./companyQueryKeys";

export function useMutationCompany({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      clubId,
      payload,
    }: {
      clubId: number;
      payload: Parameters<ApiType["companyApi"]["updateDetails"]>[1];
    }) => {
      return await api.companyApi.updateDetails(clubId, payload);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: companyQueryKeys.all() });
    },
  });
}
